
import { Link } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";
import { AuthDropdown } from "@/components/AuthDropdown";

export default function NavBar() {
  return (
    <nav className="flex justify-between items-center py-4 px-6 md:px-12 lg:px-24 bg-[#3f89d6]/90">
      <div className="flex gap-8 items-center">
        <Link to="/" className="text-white font-medium text-lg">Home</Link>
        <Link to="/blog" className="text-white font-medium text-lg">Blog</Link>
        <Link to="/contact" className="text-white font-medium text-lg">Contact</Link>
      </div>
      <div className="flex items-center gap-4">
        <ThemeToggle />
        <AuthDropdown />
      </div>
    </nav>
  );
}
